<template>
    <el-container class="list-page">
        <el-header class="list-page-header">
            <h1 class="list-page-title">{{pageTitle}}</h1>
            <div class="list-page-search">
                <el-input prefix-icon="el-icon-search" v-model="searchContent"
                          :placeholder="searchPlaceholder"></el-input>
            </div>
            <el-button class="list-page-add-button" type="primary" :disabled="cantAddInvoice" @click.native.prevent="goAddInvoice">
                <i class="el-icon-plus"></i>
                <span>{{addButtonText}}</span>
            </el-button>
        </el-header>
        <el-main class="list-page-main">
            <template>
                <div class="list-table-card">
                    <el-table class="list-table" @sort-change="sortTable" v-loading="loading" :data="tableData"
                              :default-sort = "{prop: 'invoiceStartDate', order: 'descending'}"
                              @row-click='handleRowHandle'>
                        <el-table-column prop="numPrefix,num" label="Number" sortable="custom" min-width="130">
                            <template slot="header">
                                <span class="list-sort-header" :class="{'is-active': orderName === 'numPrefix,num'}">
                                    Number
                                    <svg v-if="orderName === 'numPrefix,num'" class="list-sort-icon is-active" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                        <path v-if="orderName === 'numPrefix,num' && orderTpe === 1" d="M8 6L12 2L16 6"/>
                                        <path v-else d="M8 18L12 22L16 18"/>
                                        <path d="M12 2V22"/>
                                    </svg>
                                </span>
                            </template>
                            <template slot-scope="scope"> {{scope.row.numPrefix}}{{scope.row.num}}</template>
                        </el-table-column>
                        <el-table-column prop="userClientName" label="Client" min-width="150">
                            <template slot-scope="scope">
                                <span class="list-client-name" v-if="scope.row.userClientName">{{scope.row.userClientName}}</span>
                                <span class="list-cell-empty" v-else>—</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="invoiceStartDate" label="Date" :formatter="dateFormat" sortable="custom" min-width="150">
                            <template slot="header">
                                <span class="list-sort-header" :class="{'is-active': orderName === 'invoiceStartDate'}">
                                    Date
                                    <svg v-if="orderName === 'invoiceStartDate'" class="list-sort-icon is-active" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                        <path v-if="orderName === 'invoiceStartDate' && orderTpe === 1" d="M8 6L12 2L16 6"/>
                                        <path v-else d="M8 18L12 22L16 18"/>
                                        <path d="M12 2V22"/>
                                    </svg>
                                </span>
                            </template>
                        </el-table-column>
                    <!--<el-table-column prop="dueDate" label="Due date" sortable="custom">
                        <template scope="scope">
                            {{formatDueDate2(scope.row.dueDate,scope)}}
                            <el-tag size="mini" color="#1fca34" style="color: white" v-if="scope.row.paidStatus=== 2 && scope.row.totalMoney>0">Fully paid</el-tag>
                            <el-tag size="mini" color="#e8a944" style="color: white" v-else-if="scope.row.paidStatus=== 1 && Date.parse(new Date())<=scope.row.dueDate*1000">Partial</el-tag>
                            <el-tag color="#F42E46" style="color: white" size="mini" v-else-if="Date.parse(new Date())>scope.row.dueDate*1000 && scope.row.totalMoney>0">
                                Overdue
                            </el-tag>
                        </template>
                    </el-table-column>-->
                        <el-table-column prop="emailed" label="Email" min-width="130">
                            <template slot-scope="scope">
                                <span class="list-status-badge list-status-blue" v-if="scope.row.emailed=== 0">Unsent</span>
                                <span class="list-status-badge list-status-blue" v-else-if="scope.row.emailed=== 1">Sent</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" label="Status" min-width="130">
                        </el-table-column>

                        <el-table-column prop="totalMoney" :formatter="amountFormat" label="Total" sortable="custom" min-width="140" align="right" header-align="right">
                            <template slot="header">
                                <span class="list-sort-header" :class="{'is-active': orderName === 'totalMoney'}">
                                    Total
                                    <svg v-if="orderName === 'totalMoney'" class="list-sort-icon is-active" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                        <path v-if="orderName === 'totalMoney' && orderTpe === 1" d="M8 6L12 2L16 6"/>
                                        <path v-else d="M8 18L12 22L16 18"/>
                                        <path d="M12 2V22"/>
                                    </svg>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="70" align="right" header-align="right" class-name="list-action-column">
                            <template slot-scope="scope">
                                <el-dropdown trigger="click" @command="handleEstimateAction($event, scope.row)" @click.native.stop>
                                    <button type="button" class="invoice-list-action-button" @click.stop>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2F77F1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                            <circle cx="12" cy="12" r="1"/>
                                            <circle cx="12" cy="5" r="1"/>
                                            <circle cx="12" cy="19" r="1"/>
                                        </svg>
                                    </button>
                                    <el-dropdown-menu slot="dropdown" class="invoice-list-action-menu">
                                        <el-dropdown-item command="markAsSent">Mark as Sent</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="list-pagination">
                    <el-pagination
                            @size-change="changeTotalCount"
                            @current-change="changePage"
                            :current-page="currentPage"
                            :page-sizes="[50, 100, 200, 400]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCount">
                    </el-pagination>
                </div>

            </template>
        </el-main>
    </el-container>
</template>

<script>
    import {formatEnglishDate, getDaysByDateString} from '@/utils/time'
    import {debounce} from '@/utils/debounce'
    import {xiaoshudianfenge} from '@/utils/moneyFormat'
    import {syncCompanySelection} from '@/utils/company'
    import {openFastSpringPage} from '@/utils/subscription'

    export default {
        methods: {
            goAddInvoice() {
                this.loginInformation = JSON.parse(localStorage.getItem("loginInformation")).objectData;
                if (this.totalTypeCount > 5 && this.loginInformation.expiresTime * 1000 < Date.parse(new Date())) {
                    openFastSpringPage();
                    return;
                }

                let self = this;
                self.$router.push({path: '/createEstimate', query: {type: this.invoiceType}});
            },
            queryCompanyAndInvoiceList() {
                let that = this;
                this.loading = true;
                this.cantAddInvoice = true;
                this.$axios.post('query_setting_and_company', {
                    params: {}
                }).then(response => {
                    if (response.data.errorCode === 0) {
                        syncCompanySelection(response.data);
                        that.queryList();
                        return;
                    }
                    that.loading = false;
                    that.cantAddInvoice = false;
                }).catch(function () {
                    that.loading = false;
                    that.cantAddInvoice = false;
                })
            },
            queryList() {
                let that = this;
                this.loading = true;
                this.cantAddInvoice = true;
                this.$axios.post('query_invoice_list_user_web', {
                    params: {
                        "currentPage": that.currentPage,
                        "pageSize": that.pageSize,
                        "numberOrClient": that.searchContent,
                        "orderName": that.orderName,
                        "orderTpe": that.orderTpe,
                        "type": that.invoiceType
                    }
                }).then(response => {
                    if (response.data.errorCode === 0) {
                        that.tableData = response.data.dataList;
                        that.totalCount = response.data.totalCount;
                        that.totalTypeCount = response.data.totalTypeCount;
                        that.userSetting = JSON.parse(localStorage.getItem('userSetting'));
                    }
                    that.loading = false;
                    that.cantAddInvoice = false;

                }).catch(function () {
                    that.loading = false;
                    that.cantAddInvoice = false;
                })
            },
            sortTable(column) {
                if (!column.order) {
                    this.orderName = "";
                    this.orderTpe = "";
                    this.queryList();
                    return;
                }
                this.orderName = column.prop;
                if (column.order === "ascending") {
                    this.orderTpe = 1
                } else if (column.order === "descending") {
                    this.orderTpe = 2
                }
                this.queryList();
            },
            changePage(val) {
                this.currentPage = val;
                this.queryList();
            },
            changeTotalCount(val) {
                this.pageSize = val;
                this.queryList();
            },
            handleRowHandle(row, event, column) {
                //点击每一条列表数据触发的方法
                if (column.className === "el-table-column--selection" || column.className === "list-action-column") {
                    return false;
                } else {
                    //因为需要考虑详情里面的刷新 所以把拿过去的信息放在缓存里面
                    this.$router.push({path: 'updateEstimate', query: {innerUUID: row.innerUUID, type: this.invoiceType}});
                }
            },
            handleEstimateAction(command, row) {
                if (command === 'markAsSent') {
                    this.markEstimateAsSent(row);
                }
            },
            markEstimateAsSent(row) {
                this.$axios.post('update_invoice', {
                    params: {
                        innerUUID: row.innerUUID,
                        emailed: 1
                    }
                }).then(response => {
                    if (response.data.errorCode === 0) {
                        row.emailed = 1;
                    }
                }).catch(() => false)
            },
            //时间格式化
            dateFormat: function (row, column) {
                var timestamp = row[column.property] * 1000;
                if (timestamp == undefined) {
                    return "";
                }
                return formatEnglishDate(timestamp);
            },
            //格式化过期时间
            formatDueDate: function (row, column) {
                let timestamp = row[column.property] * 1000;
                if (timestamp == undefined) {
                    return "";
                }
                let dueDays = getDaysByDateString(Date.parse(new Date()), timestamp);
                if (dueDays === 0) {
                    return 'Today';
                } else if (dueDays < 0) {
                    return Math.abs(dueDays) + " days ago";
                } else {
                    return "in " + dueDays + " days";
                }
            },
            //格式化过期时间
            formatDueDate2: function (row,scope) {

                if (scope.row.totalMoney<=0){
                    return "";
                }
                let timestamp = row * 1000;
                if (timestamp == undefined) {
                    return "";
                }
                let dueDays = getDaysByDateString(Date.parse(new Date()), timestamp);
                if (dueDays === 0) {
                    return 'Today';
                } else if (dueDays < 0) {
                    return Math.abs(dueDays) + " days ago";
                } else {
                    return "in " + dueDays + " days";
                }
            },

            //金钱格式化,增加金钱符号和分隔符
            amountFormat: function (row, column) {
                var columnAmount = row[column.property];
                if (columnAmount == undefined) {
                    return "";
                }
                return xiaoshudianfenge(columnAmount, this.userSetting);
            }

        },
        created() {

        },
        computed: {
            invoiceType() {
                return this.$route.path === '/purchaseOrder' ? 2 : 1;
            },
            pageTitle() {
                return this.invoiceType === 2 ? "Purchase Orders" : "Estimates";
            },
            searchPlaceholder() {
                return this.invoiceType === 2 ? "Search your purchase orders" : "Search your estimates";
            },
            addButtonText() {
                return this.invoiceType === 2 ? "Add purchase order" : "Add estimate";
            }
        },
        data() {
            return {
                tableData: [],
                loading: true,
                currentPage: 1,
                totalCount: 0,
                pageSize: 50,
                searchContent: "",
                orderName: "invoiceStartDate",
                orderTpe: 2,
                userSetting: {},
                cantAddInvoice: false,
                totalTypeCount:0
            }
        },
        mounted() {
            this.queryCompanyAndInvoiceList();
            this.$watch('searchContent', debounce(() => {
                this.queryList();
            }, 500));
            this.$watch('$route.path', () => {
                this.currentPage = 1;
                this.searchContent = "";
                this.queryCompanyAndInvoiceList();
            })
        }
    }
</script>
